import { AiOutlineEye } from "react-icons/ai";
import atoms from "../../atoms";
import constant from "../../../constants/constant";
import { TWarrantyOrgProps } from "./interface";
import { Warranty_Table_Columns } from "./tableColumns";

const { Table, Button, Pagination, Search, Select } = atoms;

const statusOptions = [
    { value: constant.VERIFICATION_STATUS.PENDING, label: "Pending" },
    { value: constant.VERIFICATION_STATUS.VERIFIED, label: "Approve" },
    { value: constant.VERIFICATION_STATUS.REWORK, label: "Rework" }
];

const Index = ({
    params,
    handleParams,
    warrantyData,
    setShowSidebarModal,
    getWarrantyProductDetail,
    storeList,
}: TWarrantyOrgProps) => {
    return (
        <>
            <div className="row mb-3 align-items-center">
                <div className="col-sm-6 col-md-4 col-lg-6 mb-2 mb-md-0">
                    <Search searchCallBack={(e: string) => handleParams("search", e)} />
                </div>
                <div className="col-md-4 col-lg-3 mb-2 mb-md-0">
                    <Select
                        options={storeList}
                        className={"w-100"}
                        placeholder={"Select Store"}
                        value={params?.store}
                        isClearable={true}
                        onChange={(e: any) => {
                            handleParams("store", e);
                        }}
                    />
                </div>
                <div className="col-md-4 col-lg-3 mb-2 mb-md-0">
                    <Select
                        options={statusOptions}
                        className={"w-100"}
                        placeholder={"Select Status"}
                        value={params?.status}
                        isClearable={true}
                        onChange={(e: any) => {
                            handleParams("status", e);
                        }}
                    />
                </div>
            </div>
            <div>
                <Table
                    columns={Warranty_Table_Columns}
                    className="inventory-product-border"
                    data={warrantyData?.data?.map((item: any, index: number) => {
                        return {
                            ...item,
                            verification_status:
                                item.claim_approval_status ===
                                    constant.VERIFICATION_STATUS.PENDING ? (
                                    <div className="background-light-yellow border-product-radius">
                                        <p className="color-yellow m-1 p-1">{"Pending"}</p>
                                    </div>
                                ) : item.claim_approval_status ===
                                    constant.VERIFICATION_STATUS.VERIFIED ? (
                                    <div className="background-light-green border-product-radius">
                                        <p className="color-green m-1 p-1">{"Approve"}</p>
                                    </div>
                                ) : item.claim_approval_status ===
                                    constant.VERIFICATION_STATUS.REWORK ? (
                                    <div className="background-light-red border-product-radius">
                                        <p className="color-red m-1 p-1">{"Rework"}</p>
                                    </div>
                                ) : (
                                    ""
                                ),
                            action: (
                                <div style={{ overflow: "unset", textOverflow: "unset" }}>
                                    <Button
                                        className="table-edit-buttons fs-14 fw-500"
                                        onClick={() => {
                                            getWarrantyProductDetail(item.id);
                                            setShowSidebarModal(true);
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEye className="fs-20" />
                                            <span className="ms-2 mb-0">View</span>
                                        </div>
                                    </Button>
                                </div>
                            ),
                        };
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={warrantyData?.count}
                    currentPage={params?.currentPage}
                    totalPages={warrantyData?.totalPages}
                    onChangePage={(page: any) => handleParams("currentPage", page)}
                    setLimit={(e: number) => handleParams("limitPerPage", e)}
                    limit={params?.limitPerPage}
                />
            </div>
        </>
    );
};

export default Index;
